document.addEventListener('DOMContentLoaded', () => {
    const overlay = document.createElement('div');
    overlay.className = 'image-popup-overlay';
    overlay.innerHTML = '<span class="image-popup-close">&times;</span><img src="" alt="">';
    document.body.appendChild(overlay);

    const img = overlay.querySelector('img');

    document.querySelectorAll('a.zoom').forEach((link) => {
        link.addEventListener('click', (e) => {
            e.preventDefault();
            img.src = link.href;
            img.alt = link.querySelector('img') ? link.querySelector('img').alt : '';
            overlay.classList.add('is-open');
        });
    });

    overlay.addEventListener('click', () => {
        overlay.classList.remove('is-open');
        img.src = '';
    });

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            overlay.classList.remove('is-open');
            img.src = '';
        }
    });
});
